<template>
  <footer
    class="footer container-home"
    style="display: flex; justify-content: space-between; width: 100%"
  >
    <div class="left-links">
      <FooterLinkSection />
    </div>
    <v-card-title v-text="appInfo.appName" />
    <div class="social-icons">
      <v-icon
        v-if="appInfo.facebook"
        class="pr-3"
        @click="openSocialUrl(appInfo.facebook)"
        v-text="'mdi-facebook'"
      />
      <v-icon
        v-if="appInfo.instagram"
        class="pr-3"
        @click="openSocialUrl(appInfo.instagram)"
        v-text="'mdi-instagram'"
      />
      <v-icon
        v-if="appInfo.snapchat"
        class="pr-3"
        @click="openSocialUrl(appInfo.snapchat)"
        v-text="'mdi-snapchat'"
      />
      <v-icon
        v-if="appInfo.youtube"
        class="pr-3"
        @click="openSocialUrl(appInfo.youtube)"
        v-text="'mdi-youtube'"
      />
      <v-icon
        v-if="appInfo.twitter"
        class="pr-3"
        @click="openSocialUrl(appInfo.twitter)"
        v-text="'mdi-twitter'"
      />
      <v-img
        v-if="appInfo.tiktok"
        class="pr-3"
        height="20px"
        width="20px"
        style="cursor: pointer"
        :src="tiktok"
        @click="openSocialUrl(appInfo.tiktok)"
      />
    </div>
  </footer>
</template>

<script>
import backgroundImage from "@/assets/img/home/background.jpg";
import tiktokImage from "@/assets/img/home/tiktok.jpeg";

export default {
  name: "FooterComponent",
  components: {
    FooterLinkSection: () => import("../components/FooterLinkSection.vue"),
  },
  computed: {
    banner: {
      get() {
        return this.$store.getters.appInfo
          ? this.$store.getters.appInfo.banner
          : backgroundImage;
      },
      set(val) {
        return val;
      },
    },
    appInfo: function () {
      return this.$store.getters.appInfo;
    },
    tiktok: {
      get() {
        return tiktokImage;
      },
    },
  },
  methods: {
    openSocialUrl(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.container-home {
  max-width: 1400px !important;
  margin: 0 auto;
}

@media screen and (max-width: 960px) {
  .container-home {
    max-width: none;
    padding: 0 15px !important;
  }
}
@media screen and (max-width: 640px) {
  .footer {
    flex-direction: column-reverse !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1400px) {
  .container-home {
    padding: 0 30px !important;
  }
}
.footer {
  background-color: #ffffff;
  height: 20vh;
  display: flex;
  flex-direction: row;
  border-top: 1px solid #c9c5c5;
  justify-content: center;
  align-items: center;
}
.separator {
  height: 1px;
  background-color: #c9c5c5;
  margin-bottom: 20px;
}

.content-x {
  display: flex !important;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.social-icons {
  //right: 20px;
  //margin-right: 25px;
  //position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.left-links {
  //left: 20px;
  ////margin-right: 25px;
  //position: absolute;
}

.social-icon {
  display: inline-block;
  font-size: 20px;
  color: #333;
}

.social-icon:hover {
  color: #007bff;
}
</style>
